/**
 * Extract YouTube video ID from various YouTube URL formats
 * Supports: youtube.com/watch?v=xxx, youtu.be/xxx, youtube.com/embed/xxx
 */
export const extractYoutubeId = (url: string): string | null => {
  if (!url) return null;

  // Remove protocol if present
  const urlStr = url.replace(/^https?:\/\//, '');

  // youtu.be/xxxx format
  const youtuShortMatch = urlStr.match(/^youtu\.be\/([a-zA-Z0-9_-]+)/);
  if (youtuShortMatch) {
    return youtuShortMatch[1];
  }

  // youtube.com/watch?v=xxxx format
  const watchMatch = urlStr.match(/(?:youtube\.com\/watch\?v=|youtube\.com\/.*[?&]v=)([a-zA-Z0-9_-]+)/);
  if (watchMatch) {
    return watchMatch[1];
  }

  // youtube.com/embed/xxxx format
  const embedMatch = urlStr.match(/youtube\.com\/embed\/([a-zA-Z0-9_-]+)/);
  if (embedMatch) {
    return embedMatch[1];
  }

  return null;
};

/**
 * Check if URL is a YouTube URL
 */
export const isYoutubeUrl = (url: string): boolean => {
  return extractYoutubeId(url) !== null;
};

/**
 * Convert YouTube URL to embed URL
 */
export const getYoutubeEmbedUrl = (url: string): string | null => {
  const videoId = extractYoutubeId(url);
  if (!videoId) return null;
  return `https://www.youtube.com/embed/${videoId}`;
};
